export enum DeliveryTypes {
    CargoForFumigation = 1,
    CargoForWarehouse = 2,
    CargoForExport = 3,
    EmptyContainer = 4,
    ColdReColdTreatment = 5,
}
